import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";

// Controller for tom-select input
export default class extends Controller {
  static targets = ["select"];

  connect() {
    this.initializeTomSelect();
  }

  disconnect() {
    this.destroyTomSelect();
  }

  initializeTomSelect() {
    // Prevent double initialization
    if (this.tomSelect || this.selectTarget.tomselect) {
      return;
    }

    const config = this.buildConfig();
    this.tomSelect = new TomSelect(this.selectTarget, config);

    // Apply responsive styling if needed
    this.applyResponsiveStyling();
  }

  destroyTomSelect() {
    if (this.tomSelect) {
      this.tomSelect.destroy();
      this.tomSelect = null;
    }
  }

  buildConfig() {
    return {
      allowEmptyOption: true,
      maxOptions: null, // Show all options without limiting
      placeholder: this.selectTarget.dataset.placeholder || "",
      ...this.getSortConfig(),
      ...this.getSearchConfig(),
      render: this.getRenderConfig(),
    };
  }

  getSortConfig() {
    if (this.selectTarget.dataset.sort === "false") {
      return {};
    }

    return {
      sortField: {
        field: "text",
        direction: "asc",
      },
    };
  }

  getSearchConfig() {
    if (this.selectTarget.dataset.search === "false") {
      return { controlInput: null };
    }

    return {};
  }

  getRenderConfig() {
    const hasOptionDescriptor =
      this.selectTarget.dataset.optionDescriptor !== undefined && this.selectTarget.dataset.optionDescriptor !== null;

    if (!hasOptionDescriptor) {
      return {};
    }

    return {
      option: function (data, escape) {
        return `<div>
                 <span class="text">
                   ${escape(data.text)}
                 </span>
                 <span class="description">
                   ${escape(data.description || "")}
                 </span>
               </div>`;
      },
      item: function (data, escape) {
        return '<div text="' + escape(data.description) + '">' + escape(data.text) + "</div>";
      },
    };
  }

  // Resize height of dropdown content if data attribute 'size' is present (currently only supports 100% height)
  applyResponsiveStyling() {
    if (this.selectTarget.dataset.size === "all" && this.tomSelect?.dropdown_content) {
      this.tomSelect.dropdown_content.classList.add("responsive-content");
    }
  }
}
